import React from 'react'

const CardLink: React.FC<{ text: string, href: string, img: string, coupon?: string, perc?: number, price?: number }> = ({ coupon, text, href, img, perc, price }) => {

    return <a href={href} className='card'>
        <img className='cardImg' src={img}></img>

        <div className='verticalDivCenter'>
            <span>{text}</span>
            {coupon && <span className='coupon'>COUPON: {coupon}</span>}
            {coupon && perc && <span className='coupon'>sconto del {perc}%</span>}
            {coupon && price && <span className='coupon'>prezzo fisso {price}€</span>}
        </div>

    </a>
}

export default CardLink